<template>
    <div class="end-node">
        <div class="end-node-circle"></div>
        <div class="end-node-text">流程结束</div>
    </div>
</template>
<script>
    export default {}
</script>
<style scoped src="../../assets/flow-design.css"></style>